// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"wtr-sidebar_sidebar__2-5f9","scroll":"wtr-sidebar_scroll__AP8Vk"};